const machine_txt = {
    type: "VA-9820",
    name: "COMPUTERIZED EYELET BUTTON-HOLING SEWING MACHINE",
    description: [
        "Dry machine head, DLC plated needle rod and thread take-up rod Using lubricating grease lubrication, there is no need to worry about contaminating the sewing material",
        "306mm x 286mm Wide operating space, which can effectively meet the operator's various fabric sewing requirements",
        "International general graphics interface, U disk programme upgraded. Multifunctional Large-sized LCD Touch Button Panel easy operation. All kinds of patterns restored, make adjustment for all parameters easily and accurately.",
        "Achieve 2700rpm the maximum speed in the world, increase working efficiency,the pioneer touch screen operation system,energy saving small motor, humanity and easily operate light design, etter working experience, more beautiful and stables titch, much more better sup port for high quality garment product.",
        "Widely used for all kinds of cloth material, such as jeans, knitting, suit etc. easiy against light or heawy material, optional LCD display easily for operation, high ends and elegant.",
        "Common Specifications",
        "Max speed:2700rpm.",
        "Cutting super short thread and reserved safety end thread length is adjustable.",
        "Standard configuration with multi-functional large key screen",
        "Fast transmission by USB",
        "Auto trimmer short thread, no need man-work trim steps",
        "Upgraded Y shaft feeding mechanism, more pattern accurate and more reliable performance",
    ],
    //绝对路径
    machine_img:[
        "/assets/machine/12/machine_img/1.jpg",
    ],
    machine_other_img:[
        "/assets/machine/12/machine_other/1.png",
        "/assets/machine/12/machine_other/2.png",
    ]
}
export default {machine_txt}